module.exports = __webpack_public_path__ + "static/img/gold 1.0196b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/gold 1.png
// module id = /jCS
// module chunks = 35